import React, { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'

interface AuthInputProps {
  label: string
  type: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  required?: boolean
  error?: string
  disabled?: boolean
  className?: string
  'data-testid'?: string
}

export function AuthInput({
  label,
  type,
  value,
  onChange,
  placeholder,
  required = false,
  error,
  disabled = false,
  className = '',
  'data-testid': dataTestId
}: AuthInputProps) {
  const [showPassword, setShowPassword] = useState(false)
  const isPassword = type === 'password'
  const inputType = isPassword && showPassword ? 'text' : type

  return (
    <div className={`form-group ${className}`}>
      <label
        className={`form-label ${required ? 'form-label-required' : ''}`}
        data-testid={dataTestId ? `${dataTestId}-label` : undefined}
      >
        {label}
      </label>

      <div className="relative">
        <input
          type={inputType}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          className={`form-input w-full ${error ? 'form-input-error' : ''} ${isPassword ? 'pr-12' : ''}`}
          data-testid={dataTestId}
        />

        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 text-brand-gray hover:text-brand-primary transition-colors"
            data-testid={dataTestId ? `${dataTestId}-toggle` : undefined}
          >
            {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
          </button>
        )}
      </div>

      {error && (
        <div
          className="form-error"
          data-testid={dataTestId ? `${dataTestId}-error` : undefined}
        >
          {error}
        </div>
      )}
    </div>
  )
}